module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAA3ElEQVQ4jd2TIQoCQRSGv3WEKaY5gR5AMFrEtuBosYhXELQY7WZBg1cQk7KwYarJJl5AT7DJMmFYywbB3WEXTH5t3gwf7z3+CdrrFB/K6DQJ46Do/r6CmtdQkp9I6nlFZfQC2AAiO6eAA5ZJGG9LdZKE8Q4YI+TLNqcg5AsY5wkKJZkowtmefB6uONtLwjiqNM6H6AZ0fW+8nVQh6PcH/qCUoO4LUhl+FjbvYpXRHWAPzLIl51LYiTJ6iJAX25p0EfKijB5Vkiij58AZZxvycQRnG8Apq38R/NcvfgNLVUgkAL7pygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/08c.png
// module id = RrqU
// module chunks = 64